module.exports = __webpack_public_path__ + "img/baggage.8890b391.png";